"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripSlateDataAttributes = void 0;
// Remove redundant data attributes
var stripSlateDataAttributes = function stripSlateDataAttributes(rawHtml) {
  return rawHtml.replaceAll(/ data-slate(?:-node|-type|-leaf)="[^"]+"/g, '').replaceAll(/ data-testid="[^"]+"/g, '');
};
exports.stripSlateDataAttributes = stripSlateDataAttributes;